<template>
  <div
    id="content-body"
    class="content-body"
  >
    <div
      :class="wrapperClass"
      class="wysiwyg-content-region"
    >
      <div v-html="wysiwgBody" />
    </div>
  </div>
</template>

<script>
import wysiwygContentMixin from '../common-wysiwyg-config'

export default {
  mixins: [
    wysiwygContentMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: false,
      default: 'body'
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

::v-deep  .wysiwyg-content-region {

  h1,h2,h3,h4,h5 {
    color: var(--main-text-heading-color);
  }
  .lead {
    font-size: 1.45em;
  }
  a {
    color:var(--main-link-color);
    border-bottom: 2px solid;
    @include transition(border-color 0.3s);
    border-color: var(--main-border-color);
    @include hover-focus {
      text-decoration: none;
      border-color:var(--main-link-color);
    }
  }

  ul, ol {
    padding-left: 0.2em;
    margin: 0em 0em 1em 0em;
    overflow: auto;
    li {

      margin: 0.5em 0em 0.5em 1.5em;
    }
  }
  ul {
    li  {
      list-style-position: outside;
      list-style-type: disc;
    }
  }


  blockquote {
    border-left: 4px solid;
    font-style: italic;
    border-color: var(--main-border-color);
    padding-left: 2em;
    padding: 0.5em 0em 0.5em 2em;
    margin: 2em 0em;
    p {
      font-style: italic;
      font-size: 1.1em;
    }
  }

  //quill specific
  .ql-align-right {
    text-align: right;
  }
  .ql-align-center {
    text-align: center;
  }
}
</style>
